module.exports = __webpack_public_path__ + "SC02_03.f595cc87.png";